import { DOMSerializer } from '@tiptap/pm/model';

export const processSelectedContent = (
  editor,
  setSelectedText,
  setSelectedHtml
) => {
  const { doc, selection } = editor.state;
  const { from, to } = selection;
  const newSelectedText = doc.textBetween(from, to);

  const trackAllSelectedNodes = [];
  editor.state.doc.nodesBetween(from, to, (node, pos, parent, index) => {
    trackAllSelectedNodes.push({ node, pos, parent, index });
  });

  const selectedNodesLength = trackAllSelectedNodes?.length;

  const startingNode = trackAllSelectedNodes[1]?.pos;
  const endingNode =
    trackAllSelectedNodes[selectedNodesLength - 1]?.pos +
    trackAllSelectedNodes[selectedNodesLength - 1]?.node?.nodeSize;

  const selectedContentNodes = editor.state.doc.cut(startingNode, endingNode);

  if (from && to) {
    setSelectedText(newSelectedText);
    const serializer = DOMSerializer.fromSchema(editor.schema);
    const html = serializer.serializeFragment(selectedContentNodes);
    const container = document.createElement('div');
    container.appendChild(html);

    // Extract only the <li> elements if present
    const listItems = container.querySelectorAll('li');
    if (listItems.length > 0) {
      container.innerHTML = ''; // Clear the container
      listItems.forEach((item) => container.appendChild(item)); // Append only <li> elements
    }

    setSelectedHtml(container?.innerHTML);
  }
};
